export const removeUndefinedValues = <T extends Record<string, any>>(obj: T): Partial<T> =>
	Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== undefined)) as Partial<T>;
